import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { DeviceService } from '../service/device.service';
import { Overlay } from "@angular/cdk/overlay";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PeriodicExecution } from '../model/periodicExecution';
import { ProgrammedExecution } from '../model/programmedExecution';
import { MatTableDataSource } from '@angular/material/table';
import { DevicePilomat } from '../model/devicePilomat';
import { AddProgrammedExecutionsComponent } from '../add-programmed-executions/add-programmed-executions.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-executions',
  templateUrl: './executions.component.html',
  styleUrls: ['./executions.component.css']
})
export class ExecutionsComponent implements OnInit {

  filterString: string;

  programmedExecutionsString = $localize`:@@programmed_executions_programmed_executions_string:Automatismi programmati`;
  periodicExecutionsString = $localize`:@@programmed_executions_periodic_executions_string:Automatismi periodici`;
  automationsString = $localize`:@@programmed_executions_automations_string:Automazioni`;

  userCanExecutionEdit: boolean = false;

  hasV123: boolean = false;

  backgroundImage: string = "";
  showBackGroundImage: string[] = ["questura@pilomat.com", "questura1@pilomat.com", "gestore@1control.it", "gestore@pilomat.com"];

  constructor(
    private appComponent: AppComponent,
    private deviceService: DeviceService,
    private userService: UserService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.getUserEmail();
    this.checkPermissions();
    this.getDevices();
  }

  async checkPermissions() {
    const isAlias = await this.appComponent.isAlias();
    if (isAlias) {
      this.userCanExecutionEdit = await this.checkAliasPermissions("ExecutionEdit");
    } else {
      this.userCanExecutionEdit = true;
    }
  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }


  getDevices() {
    this.deviceService.getDevices().subscribe(devices => {

      //Verifico se mostrare la tab delle automazioni
      for (let device of devices) {
        if (device.systemInfo.version >= DevicePilomat.MIN_VER_FORCEDLOW_REASON) {
          this.hasV123 = true;
          break;
        }
      }

      this.cdRef.detectChanges();
    });
  }

  getUserEmail() {
    this.userService.getFirebaseUserObs().subscribe(firebaseUser => {
      this.userService.getMe().subscribe(user => {
        if (this.showBackGroundImage.includes(user.email)) {
          this.backgroundImage = "url('assets/img/Banner_pconnect_Milano_day.jpg')";
        } else {
          this.backgroundImage = "unset"
        }
      }, errorRes => {
        Log.debug("error cannot retrieve user ");
      });
    }, errorRes => {
      Log.debug("error cannot retrieve user ");
    });
  }

}
